import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './authConfig';
import App from './App';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
} else {
  console.error("Root container is missing in the HTML file");
}